import type { ComponentType, LazyExoticComponent } from "react";
import React from "react";

export const clientsConfig = {
  mobile: {
    title: "Winamp Player",
    pages: {
      Root: React.lazy(() => import("~/clients/mobile/routes/Root")),
      Login: React.lazy(() => import("~/clients/mobile/routes/Login")),
      LoginMagicLink: React.lazy(
        () => import("~/clients/mobile/routes/Login/MagicLink"),
      ),
      LoginMagicLinkConfirmation: React.lazy(
        () => import("~/clients/mobile/routes/Login/MagicLink/Confirmation"),
      ),
      LoginPassword: React.lazy(
        () => import("~/clients/mobile/routes/Login/Password"),
      ),
      Register: React.lazy(() => import("~/clients/mobile/routes/Register")),
      RegisterConfirmation: React.lazy(
        () => import("~/clients/mobile/routes/Register/Confirmation"),
      ),
      RegisterOnboarding: React.lazy(
        () => import("~/clients/mobile/routes/Register/Onboarding"),
      ),
      RegisterOnboardingComplete: React.lazy(
        () => import("~/clients/mobile/routes/Register/Onboarding/Complete"),
      ),
      RegisterOnboardingCollaborator: React.lazy(
        () =>
          import("~/clients/mobile/routes/Register/Onboarding/Collaborator"),
      ),
      ForgotPassword: React.lazy(
        () => import("~/clients/mobile/routes/ForgotPassword"),
      ),
      ForgotPasswordConfirmation: React.lazy(
        () => import("~/clients/mobile/routes/ForgotPassword/Confirmation"),
      ),
      ForgotPasswordReset: React.lazy(
        () => import("~/clients/mobile/routes/ForgotPassword/Reset"),
      ),
      UnknownEmail: React.lazy(
        () => import("~/clients/mobile/routes/Errors/UnknownEmail"),
      ),
    },
  },
  default: {
    title: "Winamp for Creators",
    pages: {
      Root: React.lazy(() => import("~/clients/default/routes/Root")),
      Login: React.lazy(() => import("~/clients/default/routes/Login")),
      LoginMagicLink: React.lazy(
        () => import("~/clients/default/routes/Login/MagicLink"),
      ),
      LoginMagicLinkConfirmation: React.lazy(
        () => import("~/clients/default/routes/Login/MagicLink/Confirmation"),
      ),
      LoginPassword: React.lazy(
        () => import("~/clients/default/routes/Login/Password"),
      ),
      Register: React.lazy(() => import("~/clients/default/routes/Register")),
      RegisterConfirmation: React.lazy(
        () => import("~/clients/default/routes/Register/Confirmation"),
      ),
      RegisterOnboarding: React.lazy(
        () => import("~/clients/default/routes/Register/Onboarding"),
      ),
      RegisterOnboardingComplete: React.lazy(
        () => import("~/clients/default/routes/Register/Onboarding/Complete"),
      ),
      RegisterOnboardingCollaborator: React.lazy(
        () =>
          import("~/clients/default/routes/Register/Onboarding/Collaborator"),
      ),
      ForgotPassword: React.lazy(
        () => import("~/clients/default/routes/ForgotPassword"),
      ),
      ForgotPasswordConfirmation: React.lazy(
        () => import("~/clients/default/routes/ForgotPassword/Confirmation"),
      ),
      ForgotPasswordReset: React.lazy(
        () => import("~/clients/default/routes/ForgotPassword/Reset"),
      ),
      UnknownEmail: React.lazy(
        () => import("~/clients/default/routes/Errors/UnknownEmail"),
      ),
    },
  },
} satisfies Record<ClientId, ClientConfig>;

export type ClientId = "mobile" | "default";
type Page =
  | "Root"
  | "Login"
  | "LoginMagicLink"
  | "LoginMagicLinkConfirmation"
  | "LoginPassword"
  | "Register"
  | "RegisterConfirmation"
  | "RegisterOnboarding"
  | "RegisterOnboardingComplete"
  | "RegisterOnboardingCollaborator"
  | "ForgotPassword"
  | "ForgotPasswordConfirmation"
  | "ForgotPasswordReset"
  | "UnknownEmail";

type ClientConfig = {
  title: string;
  pages: Record<Page, LazyExoticComponent<ComponentType>>;
};
